import { CloseRounded } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography, useTheme } from '@mui/material'
import 'react-dropzone-uploader/dist/styles.css'
import { CancelButton, SaveButton } from '../../../../../shared/components/inputs'
import TabPanel from '../../../../../shared/components/TabPanel'
import { formsStyles } from '../../../../../shared/styles/FormsStyles'
import { useNewsModal } from '../../hooks/useNewsModal'
import { NewsAddOnsTabContent } from './NewsAddOnsTabContent'
import { NewsGeneralTabContent } from './NewsGeneralTabContent'
import { NewsModalHeader } from './NewsModalHeader'
import { StyledDialog } from '@/contexts/shared/styles/StyledDialog'
import { StyledTabs } from '@/contexts/shared/components/StyledTabs'
import useTabState from '@/contexts/shared/hooks/useTabState'
import { useTranslation } from 'react-i18next'
import { IRootState } from '@/redux/types'
import { useSelector } from 'react-redux'
import { CustomTab } from '@/contexts/backoffice/users/ui/components/modals/create/CustomTab'

function NewsModal() {
  const { t } = useTranslation(['global'])
  const theme = useTheme()
  const formClasses = formsStyles(theme)

  const { currentTab, setCurrentTab, a11yProps } = useTabState()
  const { handleCloseNewsModal, handleSubmit, noveltyState, STATUS, VISIBILITY, handleInputChange, getUploadParams } = useNewsModal()

  const { msgForm, errorTab, isValidForm } = useSelector((state: IRootState) => state.validator)
  const { showForm } = useSelector((state: IRootState) => state.novelty)

  return (
    <StyledDialog
      open={showForm}
      onClose={handleCloseNewsModal}
      aria-describedby="alert-dialog-description"
      aria-labelledby="form-dialog-title"
      disableEnforceFocus
    >
      <DialogTitle id="form-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">{`${t('create')} ${t('news')}`}</Typography>
          <Button onClick={handleCloseNewsModal} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <NewsModalHeader newState={noveltyState} handleInputChange={handleInputChange} />

        <Grid item xs={12}>
          <StyledTabs value={currentTab} onChange={(_, value) => setCurrentTab(value)} aria-label="disabled tabs example">
            <CustomTab label={t('general')} {...a11yProps(0)} error={errorTab.general} />
            <CustomTab label={t('add-ons')} {...a11yProps(1)} error={errorTab.addOn} />
          </StyledTabs>
        </Grid>

        <TabPanel value={currentTab} index={0}>
          <NewsGeneralTabContent newState={noveltyState} handleInputChange={handleInputChange} VISIBILITY={VISIBILITY} STATUS={STATUS} />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <NewsAddOnsTabContent newState={noveltyState} getUploadParams={getUploadParams} />
        </TabPanel>
      </DialogContent>

      <DialogActions sx={!isValidForm && Object.keys(msgForm).length > 0 ? formClasses.errorDialogActions : undefined}>
        <CancelButton onClick={handleCloseNewsModal}>{t('cancel')}</CancelButton>
        <SaveButton onClick={() => handleSubmit()}>{t('save')}</SaveButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default NewsModal
